import { withInstall } from '@ll-plus/utils'

import DatePicker from './src/date-picker.vue'

export const LlDatePicker = withInstall(DatePicker)
export default LlDatePicker
export * from './src/date-picker'

declare module 'vue' {
  export interface GlobalComponents {
    LlDatePicker: typeof DatePicker
  }
}
